export const defaultIconStyle = {
	size: '1rem',
};

export const inputIconStyle = {
	size: 18,
};

export const statIconStyle = {
	size: '2rem',
	color: '#868e96',
};
